import axios from "axios";
import Notify from "../../utils/useNotify";
import { useTranslation } from "react-i18next";
import { ArrowLeftStartOnRectangleIcon } from "@heroicons/react/24/solid";
import useConfirmation from "../../utils/useConfirmation";

export default function Logout({ typeProp = "" }) {
  const { t } = useTranslation();
  const { open, ConfirmComponent } = useConfirmation();
  const localhost = process.env.REACT_APP_LOCALHOST;
  const token = localStorage.getItem('token');

  const handleLogout = async () => {
    try {
      await axios.post(localhost + 'logout', null, { headers: { 'Authorization': `Bearer ${token}` } });
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      Notify("success", t("logout-msg"));
    } catch (err) {
      Notify("error", t("logout-msg-err"));
    }
  };

  const handleAction = () => {
    open(
      {
        title: t("logout-confirmation-header"),
        text: t("logout-confirmation-body"),
        action: "add",
      },
      handleLogout
    );
  };

  return (
    <>
      {ConfirmComponent}
      {
        typeProp === "settings" ? (
          <div onClick={handleAction} className="group col-span-1 cursor-pointer rounded-lg border shadow-sm bg-white p-8 hover:bg-gray-100">
            <div className="mx-auto mb-2 flex h-[54px] max-h-[54px] w-[54px] max-w-[54px] items-center justify-center rounded-full bg-gray-200 group-hover:bg-orange-200 p-2">
              <ArrowLeftStartOnRectangleIcon className='inline h-7 w-7 text-gray-500 group-hover:text-orange-500' />
            </div>
            <div className="text-center font-semibold text-sm text-gray-500 group-hover:text-orange-500">{t("logout")}</div>
          </div>
        ) : <div className="w-full h-full" onClick={handleAction}>{t("logout")}</div>
      }
    </>
  );
}